module.exports = __webpack_public_path__ + "505e5a1121a3dad472297d1d316a05ff.MP3";